<template>
  <div class="message-iframe-wrap">
    <iframe
      v-if="url"
      :src="url"
      frameborder="0"
      style="width:100%; height:100%;"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'messageList',
  data () {
    return { url: undefined }
  },
  created () {
    // console.log("shopId----:");
    const token = localStorage.getItem('token')
    const shop_id = localStorage.getItem('shop_id')
    const url =
      currentEnv == 'dev'
        ? 'http://dev.pro.ruigushop.com/notice-list'
        : currentEnv == 'test'
          ? 'https://test-pro.ruigushop.com/notice-list'
          : 'https://pro.ruigushop.com/notice-list'
    this.url = url + `?shop_id=${shop_id}&access_token=${token}`
  }
}
</script>
<style lang="scss" scoped>
.message-iframe-wrap {
  width: 100%;
  height: calc(100vh - 53px - 40px);
}
</style>



// WEBPACK FOOTER //
// src/pages/notice/messageList.vue